module.exports = __webpack_public_path__ + "img/gf.be825203.svg";